require("!../../node_modules/styles-to-js-loader/add-styles.js")("src/css/ballsNew.css", require("!!../../node_modules/css-loader/dist/cjs.js!./ballsNew.css"));